import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";
import { isEmpty } from "lodash";
import { Container } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import AppBar from "../components/headerNav/HeaderNav";
import { UserContext } from "../context/UserContext";
import MediaSearchRequest from "../components/mediaRequest/MediaSearchRequest";
import "../styles/media-search.scss";
import Footer from "../components/footer/Footer";
import { MediaRequestContextProvider } from "../context/MediaRequestContext";
import MediaRequestGrid from "../components/mediaRequest/MediaRequestGrid";
import CreateMediaRequest from "../components/mediaRequest/createMediaRequest/CreateMediaRequest";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const MediaRequest = () => {
  const { userRole } = useContext(UserContext);

  return isEmpty(userRole) ? null : (
    <Container fluid className="requestContainer">
      <Grid container>
        <MediaRequestContextProvider>
          <AppBar />
          <Grid item xs={12}>
            <Container fluid className="media-request-container">
              <Switch>
                <Route exact path="/mediaRequest">
                  <MediaSearchRequest />
                  <MediaRequestGrid />
                </Route>
                <Route exact path="/mediaRequest/create">
                  <CreateMediaRequest />
                </Route>
              </Switch>
            </Container>
          </Grid>
          <Footer />
          <CookieConsentBanner />
        </MediaRequestContextProvider>
      </Grid>
    </Container>
  );
};

export default MediaRequest;
